module.exports = __webpack_public_path__ + "static/media/heliStop.9824c2ba.png";